import React from "react";
import { Switch, Route } from "react-router-dom";
import ContentPage from "./ContentPage";
import AhfsPage from "./AhfsPage";
import NoDataMessage from "../components/NoDataMessage";

export default function Routes() {
  return (
    <Switch>
      <Route
        path={`/ahfs/:slugTitle`}
        exact
        render={({ match }) => {
          const { slugTitle } = match.params;
          return <AhfsPage slugTitle={slugTitle} />;
        }}
      />
      <Route
        path={`/:slugPubType/:slugTitle`}
        exact
        render={({ match }) => {
          const { slugPubType, slugTitle } = match.params;
          return (
            <ContentPage slugPubType={slugPubType} slugTitle={slugTitle} />
          );
        }}
      />
      <Route
        path={`/:slugPubType/:slugTitle/:tabType`}
        exact
        render={({ match }) => {
          const { slugPubType, slugTitle, tabType } = match.params;
          return (
            <ContentPage
              slugPubType={slugPubType}
              slugTitle={slugTitle}
              tabType={tabType}
            />
          );
        }}
      />
      <Route
        path={`/:slugPubType/:slugTitle/:tabType/:pathSectionId`}
        exact
        render={({ match }) => {
          const {
            slugPubType,
            slugTitle,
            tabType,
            pathSectionId,
          } = match.params;
          return (
            <ContentPage
              slugPubType={slugPubType}
              slugTitle={slugTitle}
              tabType={tabType}
              pathSectionId={pathSectionId}
            />
          );
        }}
      />
      <Route
        render={() => {
          return (
            <NoDataMessage message="We're sorry! This page doesn't exist." />
          );
        }}
      />
    </Switch>
  );
}
